<template>
    <EditBase
        v-if="event.provider ? event.provider.includes('survey') : false"
        :show-edit="showEdit"
        :question="question"
        :qNum="qNum"
        :event="event"
        :patient="patient"
        :survey="survey"
        :saving-edit="savingEdit"
        :save-disabled="!enableSave"
        :show-remove-response="showRmvResp"
        :is-mandatory="checkIfMandatory()"
        @response-removed="removeResponse()"
        @save-edit="updateQuestion()"
        @open-dialog="showEdit = true"
        @close-dialog="closePopup()">
        <div class="date inl">
            {{ qDate }}
        </div>
        <div class="unit-edit inl">
            <div class="input-num inl-fl">
                <el-input-number
                    size="small"
                    :controls="false"
                    placeholder="Enter Value"
                    v-model="updateResponse"
                    @change="onUnitValueResponseChange()">>
                </el-input-number>
                <span v-show="showUpdateResponseErrorMsg" class="error-message">
                    Enter value to continue
                </span>
            </div>
            <div class="input-sel inl-fl">
                <el-select v-model="updateUnit" size="small" placeholder="Select Unit" @change="onUnitResponseChange()">>
                    <el-option v-for="option in question.options"
                        :key="option.value"
                        :label="option.display_text"
                        :value="option.value">
                    </el-option>
                </el-select>
                <span v-show="showUpdateUnitErrorMsg" class="error-message">
                    Select unit to continue
                </span>
            </div>
            <span v-if="((updateResponse == undefined || updateResponse == null || updateResponse == '') && (updateUnit == undefined || updateUnit == null || updateUnit == ''))" class="no-answer">
                Not Answered
            </span>
        </div>
        
    </EditBase>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EditBase from './EditBase'
import QuestionEdit from './'
import { v4 as uuidv4 } from 'uuid'

export default {
    name: 'edit-unit',
    extends: QuestionEdit,

    data() {
        return {
            updateResponse: this.getQuestionResponse(),
            updateUnit: this.getUnitResponse(),
            enableSave: false,
            showRmvResp: !this.checkIfMandatory() && this.response,
        }
    },

    methods: {
        ...mapActions('provider', [
            'updateSurvey'
        ]),
        closePopup() {
            this.showEdit = false
            this.enableSave = false
            this.updateResponse = this.getQuestionResponse()
            this.updateUnit = this.getUnitResponse(),
            this.showRmvResp = !this.checkIfMandatory() && this.response
        },
        removeResponse() {
            this.updateResponse = ''
            this.updateUnit = ''
            this.showRmvResp = false
            this.enableSave = this.checkIfMandatory() ? false : true
        },
        onUnitValueResponseChange() {
            if(this.updateResponse && (this.updateResponse != null || this.updateResponse != "")) {
                    this.showRmvResp = this.checkIfMandatory() ? false : true
            } else {
                this.showRmvResp = false
            }

            this.checkEnableSaveOnResponseChange()
        },
        onUnitResponseChange() {
            if(this.updateUnit && (this.updateUnit != null || this.updateUnit != "")) {
                    this.showRmvResp = this.checkIfMandatory() ? false : true
            } else {
                this.showRmvResp = false
            }

            this.checkEnableSaveOnResponseChange()
        },
        checkEnableSaveOnResponseChange() {
            if(this.updateResponse && 
                this.updateUnit &&
                (this.updateResponse != null || this.updateResponse != "") && 
                (this.updateUnit != null || this.updateUnit != "")) {
                    this.enableSave = true
            } else this.enableSave = this.checkIfMandatory() ? false : true
        },
        updateQuestion() {
            let update = [...this.event.question]
            if(this.updateIndex !== -1)
                update[this.updateIndex] = this.getQuestionUpdate()
            else
                update.push(this.getQuestionUpdate())
            console.log(update)

            this.savingEdit = true

            this.updateSurvey({
                updateObj: {
                    id: this.event.response,
                    update
                }, 
                surveyId: this.event.id,
                provider: this.event.provider.split(':')[0],
                patient: this.patient.id,
                previousObj: this.event
                })
                .finally(() => {
                    this.savingEdit = false
                    this.enableSave = false
                    this.showEdit = false
                    this.showRmvResp = !this.checkIfMandatory() && this.response
                })
        },
        getQuestionResponse() {
            if(this.response && Array.isArray(this.response) && this.response.length > 0)
                return this.response[0].answer
            return ''
        },
        getUnitResponse() {
            if(this.response && Array.isArray(this.response) && this.response.length > 0)
                return this.response[0].value
            return ''
        },
        getQuestionUpdate() {
            let update = {
                id: this.question.id,
                answer: null
            }
            if(this.updateResponse && this.updateUnit) {
                const updateOption = this.question.options.find(({value}) => value === this.updateUnit)
                if(updateOption) {
                    let answer = {
                        value: updateOption.value,
                        display_text: updateOption.display_text,
                        answer: this.updateResponse,
                    }
                    if(this.questionResponseId())
                        answer.id = this.questionResponseId()
                    else
                        answer.id = uuidv4()
                    update.answer = [answer]
                }
            }
            return update
        },
        questionResponseId() {
            if(this.response && Array.isArray(this.response) && this.response.length > 0)
                return this.response[0].id
            return false
        },
    },

    computed: {
        showUpdateResponseErrorMsg: function() {
            if(this.updateResponse && (this.updateResponse != null || this.updateResponse != "")) {
                    return false
            } else return true
        },
        showUpdateUnitErrorMsg: function() {
            if(this.updateUnit && (this.updateUnit != null || this.updateUnit != "")) {
                    return false
            } else return true
        }
    },

    components: {
        EditBase
    }

}
</script>

<style lang="scss" scoped>
@import './style.scss';
.unit-edit {
    display: flex;
    margin: 0px 10px;

    .input-num {
        width: 150px;
    }
    .input-sel{
        width: 250px;
    }

    ::v-deep .error-message {
        color: red;
        font-size: 14px;
    }

    ::v-deep .el-select.el-select--small {
        width: 100%;
    }
}

.inl-fl {
    display: inline-flex;
    flex-direction: column;
}
</style>
